var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-badge',{key:_vm.status,attrs:{"label":_vm.label,"icon":_vm.icon,"color-class":_vm.colorClass}})}
var staticRenderFns = []

export { render, staticRenderFns }